















































































































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { PageTitle } from '@questelservices/common-vue';
import { DataGrid } from '@questelservices/common-vue';
import {
  DxColumn,
  DxEditing,
  DxForm,
  DxFormItem,
  DxHeaderFilter,
  DxLookup,  
  DxDataGrid,
  DxFilterRow,
  DxPaging
} from 'devextreme-vue/data-grid';
import { DxSelectBox, DxButton, DxTextBox, DxTextArea, DxPopup, DxTreeView, DxDropDownBox , DxToolbar, DxCheckBox} from 'devextreme-vue';
import { FeeSheetTemplateService } from '../service/FeeSheetTemplateService';
import { PhaseTypeService } from '../service/PhaseTypeService';
import { InfractionRuleService } from '../service/InfractionRuleService';
import { FeeSheetTemplateDto } from '../models/FeeSheetTemplates/FeeSheetTemplateDto';
import { FeeSheetTemplatePhaseDto } from '../models/FeeSheetTemplates/FeeSheetTemplatePhaseDto';
import { FeeSheetTemplateTaskDto } from '../models/FeeSheetTemplates/FeeSheetTemplateTaskDto';
import { FeeSheetTemplateRuleDto } from '../models/FeeSheetTemplates/FeeSheetTemplateRuleDto';
import { PhaseTypeDto } from '../models/PhaseTypeDto';
import { InfractionTypeDto } from '../models/infractions/InfractionTypeDto';
import { KeyMap } from '../models/KeyMap';
import { PhaseAliasService } from '../service/PhaseAliasService';
import { PhaseAliasDto } from '../models/PhaseAliasDto';
import _ from "lodash";
import  FeeSheetRowDialog  from '../components/fee-sheets/fee-sheet-row-dialog.vue'
import { CountryDto } from '../models/CountryDto';
import { CountryService } from '@/service/CountryService';
import { FeeSheetRowDto, FeeSheetRowTypeEnum } from '../models/Fees/FeeSheetRowDto';
import { FeeSheetModalType } from '@/models/Fees/FeeTypeEnum';
import { FeeSheetRuleDto, FeeSheetRuleTypeEnum, FeeSheetRuleLevelEnum } from '../models/Fees/FeeSheetRuleDto';
import { DxHtmlEditor } from 'devextreme-vue/html-editor';
import { JurisdictionDto } from '../models/JurisdictionDto';



@Component({
  components: {
    PageTitle,
    DxDataGrid,
    DxHeaderFilter,
    DxColumn,
    DxTextBox,
    DxButton,
    DxSelectBox,
    DxTextArea,    
    DxEditing,
    DxPopup,
    DxPaging,
    DxDropDownBox,
    DxTreeView,
    DxToolbar,
    FeeSheetRowDialog,
    DxHtmlEditor,
    DxCheckBox
  }
})
export default class FeeSheetTemplatesForm extends Vue {
  title: string = "Fee Sheet Template";
  feeSheetTemplatesService: FeeSheetTemplateService;

  ///phaseTypeDtos: Array<PhaseTypeDto> = [];
  ///phaseMultiPhaseTypes : Array<{ text: string, value: any, type:string }> = [];
  phaseNames: Array<string> = [];
  selectedPhase: any = '';
  selectedMultiphase: Guid = '';

  ///infractionTypeDtos: Array<InfractionTypeDto> = [];
  ///infractionTypes: Array<{ text: string, value: number }> = [];

  jurisdictionList : Array<JurisdictionDto> = [
            { Name : "In", Value : true},
            { Name : "Out", Value : false}
        ];

  infractionNames: Array<string> = [];
  selectedInfraction: number = 0;

  feeSheetTemplateId?: Guid;    
  templateName: string = "";  
  templateNotes: string = "";
  templateInJurisdiction: boolean = true;

  templatePhases: Array<FeeSheetTemplatePhaseDto> = [];
  templateTasks: Array<FeeSheetTemplateTaskDto> = [];
  DeletedFeeSheetTemplatePhases: Array<FeeSheetTemplatePhaseDto> = [];
  DeletedFeeSheetTemplateTasks: Array<FeeSheetTemplatePhaseDto> = [];

  errorVisible: boolean = false;
  errorMessage: string = "";
  phaseOrMultiPhase: string[] = [
        "Phase",
        "Multiphase Alias"
    ];
  readonly templateNameExists: string = "A Fee Sheet Template with this name already exists. Please choose another name.";
  readonly emptyTemplateName: string = "Please choose a Fee Sheet Template name.";
  readonly emptyPhasesOrTasks: string = "Please add at least one Phase or Task to the template.";
  readonly phaseAlreadyAdded: string = "This phase has already been added to the template. Please add a different phase.";
  readonly phaseAliasAlreadyAdded: string = "This phase alias has already been added to the template. Please add a different phase.";
  readonly taskAlreadyAdded: string = "This task has already been added to the template. Please add a different task.";  
  private phaseTypeService: PhaseTypeService;
  private phaseAliasService: PhaseAliasService;
  private countryService: CountryService;

  countryList: CountryDto[] = [];
  feeSheetRow: FeeSheetRowDto;
  private feeSheetRowType : FeeSheetRowTypeEnum = FeeSheetRowTypeEnum.Phase;
  feeSheetRowModalType : FeeSheetModalType = FeeSheetModalType.Add;
  showFeeSheetRowDialog: boolean;
  selectedPhasesInfraction: (Guid | number)[] = [];
  selectedFeeSheetTemplateId: string | undefined;

  constructor() {
    super();
    this.phaseTypeService = new PhaseTypeService();
    this.phaseAliasService = new PhaseAliasService('/api/PhaseAlias');
    this.feeSheetTemplatesService = new FeeSheetTemplateService(
      '/api/FeeSheetTemplate'
    );

    this.showFeeSheetRowDialog = false;
    this.countryService = new CountryService();

    this.processGetCountries();

    this.feeSheetRowModalType = FeeSheetModalType.Add;
    this.feeSheetRow = this.feeSheetRowDefaultValue();
  }

  created() {
    document.addEventListener('keydown', this.onKeydown);
    document.addEventListener('keyup', this.onKeyup);

    if (this.$route.params.id) {
      this.title = "Fee Sheet Template Edit";
      this.feeSheetTemplateId = this.$route.params.id;
    } else {
      this.title = "Fee Sheet Template Create";
    }

    this.loadData();
  }

  destroyed() {
    document.removeEventListener('keydown', this.onKeydown);
    document.removeEventListener('keyup', this.onKeyup);
  }

  onKeydown(event: KeyboardEvent) {
    if ((event.ctrlKey || event.shiftKey) && event.keyCode === KeyMap.enter) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  onKeyup(event: KeyboardEvent) {
    if ((event.ctrlKey || event.shiftKey) && event.keyCode === KeyMap.enter) {
      event.preventDefault();
      event.stopPropagation();
      this.saveFeeSheetTemplate();
    }
  }

async getPhaseList() : Promise<any>{
  return await this.phaseTypeService.getAll()
              .then((response : PhaseTypeDto[]) => {
                  let result = response.map((p : PhaseTypeDto, index : number) => {
                      return { text: p.PhaseName, value: p.PhaseTypeId}
                    });

                  return result;
                })
              .catch(err => []);                
}
async getPhaseAlias() : Promise<any>{
  return await this.phaseAliasService.getAll()
              .then((response : PhaseAliasDto[]) => {
                  let result = response.map((p : PhaseAliasDto, index : number) => {
                      return { text: p.Name, value: p.PhaseAliasId, type: 'Alias'}
                    });

                  return result;
                })
              .catch(err => []); 
}

  async loadData() {
    if(this.feeSheetTemplateId) {
      this.feeSheetTemplatesService.get(this.feeSheetTemplateId)
        .then(result => {
          this.templateName = result.TemplateName;
          this.templateNotes = result.Notes;
          this.templateInJurisdiction = result.InJurisdiction
          _.forEach(result.FeeSheetTemplatePhases, (item : FeeSheetTemplatePhaseDto) => {
                item.CapDisplay = '';
                this.processPhaseCapDisplay(item);
                _.forEach(item.FeeSheetTemplateRules, (fr: FeeSheetTemplateRuleDto) => {
                    if(!fr.CountryId) {
                        fr.CountryId = 0;
                    }
                })
          });
          this.templatePhases = result.FeeSheetTemplatePhases;
          _.forEach(result.FeeSheetTemplateTasks, (item : FeeSheetTemplateTaskDto) => {
                item.CapDisplay = '';
                this.processTaskCapDisplay(item);
                _.forEach(item.FeeSheetTemplateRules, (fr: FeeSheetTemplateRuleDto) => {
                    if(!fr.CountryId) {
                        fr.CountryId = 0;
                    }
                })
          });
          this.templateTasks = result.FeeSheetTemplateTasks;          
        });
    }
     
    
  }
     

    feeSheetRowDefaultValue() : FeeSheetRowDto {
        let def: FeeSheetRowDto = {
            FeeSheetRowId: "00000000-0000-0000-0000-000000000000",
            FeeSheetId: "00000000-0000-0000-0000-000000000000",
            Description: "",
            Signed: false,
            FeeSheetRules: [],
            CapDisplay : ""
        }

        return _.clone(def); 
    }

    onAddPhaseType(e:any): void {
        this.feeSheetRow = this.feeSheetRowDefaultValue();
        this.feeSheetRowType = FeeSheetRowTypeEnum.Phase;
        this.feeSheetRowModalType = FeeSheetModalType.Add;
        this.showFeeSheetRowDialog = true;
        
        let selected = this.templatePhases.map((item: FeeSheetTemplatePhaseDto) => {
            let res = item.PhaseAliasId || item.PhaseTypeId || 0;

            return res;
        });
        this.selectedPhasesInfraction = selected;
    }
    onEditPhaseType(e: any): void {
        this.feeSheetRowType = FeeSheetRowTypeEnum.Phase;
        this.processDataForEdit(e);
    }
    onDeletePhaseType(e: any): void {
        if(!this.DeletedFeeSheetTemplatePhases) {
            this.DeletedFeeSheetTemplatePhases = [];
        }

        if(e.data.FeeSheetRowId != "00000000-0000-0000-0000-000000000000") {
            this.DeletedFeeSheetTemplatePhases.push(e.data);
        }

        this.templatePhases.splice(e.rowIndex, 1);
    }

    onAddTaskType(e:any): void {
        this.feeSheetRow = this.feeSheetRowDefaultValue();
        this.feeSheetRowType = FeeSheetRowTypeEnum.Infraction;
        this.feeSheetRowModalType = FeeSheetModalType.Add;
        this.showFeeSheetRowDialog = true;
        
        let selected = this.templateTasks.map((item: FeeSheetTemplateTaskDto) => {
            let res = item.InfractionTypeId || '';

            return res;
        });

        this.selectedPhasesInfraction = selected;
    }
    onEditTaskType(e: any): void {
        this.feeSheetRowType = FeeSheetRowTypeEnum.Infraction;
        this.processDataForEdit(e);
    }
    onDeleteTaskType(e: any): void {
        if(!this.DeletedFeeSheetTemplateTasks) {
            this.DeletedFeeSheetTemplateTasks = [];
        }

        if(e.data.FeeSheetRowId != "00000000-0000-0000-0000-000000000000") {
            this.DeletedFeeSheetTemplateTasks.push(e.data);
        }

        this.templateTasks.splice(e.rowIndex, 1);
    }
 
    async processGetCountries() {
        this.countryService = new CountryService();
        this.countryList = await this.countryService.getAllDto().then((responses: CountryDto[]) => {
            let forAll : CountryDto = {
                CountryId: 0,
                CountryCode: "All"
            }

            responses.unshift(forAll);

            return responses;
        });
    }

    hidingFeeSheetRowDialog(e: FeeSheetRowDto | undefined): void {
        if(e) {
            let cloned = _.clone(e);
            if(this.feeSheetRowType === FeeSheetRowTypeEnum.Phase) {
                //add phase
                if(this.selectedFeeSheetTemplateId == undefined) {
                    let fsRowTemplate: FeeSheetTemplatePhaseDto = {
                        FeeSheetTemplatePhaseId: e.FeeSheetRowId,
                        FeeSheetTemplateId: this.feeSheetTemplateId,
                        Description: e.Description,
                        PhaseTypeId: e.PhaseTypeId,
                        PhaseType: e.PhaseType,
                        PhaseAliasId: e.PhaseAliasId,
                        PhaseAlias: e.PhaseAlias,
                        FeeSheetTemplateRules: this.convertFeeSheetTemplateRules(cloned.FeeSheetRules), 
                        CapDisplay: e.CapDisplay
                    }
                    if (e.PhaseAlias){
                        fsRowTemplate.PhaseName = e.PhaseAlias.Name;
                    }
                    else {
                        if (e.PhaseType){
                            fsRowTemplate.PhaseName = e.PhaseType.PhaseName;
                        }
                        else {
                            fsRowTemplate.PhaseName = "";
                        }
                    }

                    fsRowTemplate.FeeSheetTemplateRules = this.convertFeeSheetTemplateRules(cloned.FeeSheetRules);    

                    this.processPhaseCapDisplay(fsRowTemplate);

                    this.templatePhases.push(fsRowTemplate);
                }
                else{ //edit phase
                    let fsRowTemplate = this.templatePhases.find(x => x.FeeSheetTemplatePhaseId === this.selectedFeeSheetTemplateId);

                    if(fsRowTemplate){
                      fsRowTemplate.CapDisplay = cloned.CapDisplay;
                      fsRowTemplate.Description = cloned.Description;

                  
                      fsRowTemplate.FeeSheetTemplateRules = this.convertFeeSheetTemplateRules(cloned.FeeSheetRules);
                      fsRowTemplate.DeletedFeeSheetTemplateRules = this.convertFeeSheetTemplateRules(cloned.DeletedFeeSheetRules);
                      
                      this.processPhaseCapDisplay(fsRowTemplate);
                    }
                    
                }
            }
            else{ //task/infraction
                if(this.selectedFeeSheetTemplateId == undefined) {
                    let fsRowTemplate: FeeSheetTemplateTaskDto = {
                        FeeSheetTemplateTaskId: e.FeeSheetRowId,
                        FeeSheetTemplateId: this.feeSheetTemplateId,
                        InfractionTypeId: e.InfractionTypeId,
                        Description: e.Description,
                        FeeSheetTemplateRules: this.convertFeeSheetTemplateRules(cloned.FeeSheetRules), 
                        CapDisplay: e.CapDisplay
                    }
                    if(e.InfractionType){
                        fsRowTemplate.InfractionType = e.InfractionType;
                        fsRowTemplate.InfractionName = e.InfractionType.Name;
                    }
                    fsRowTemplate.FeeSheetTemplateRules = this.convertFeeSheetTemplateRules(cloned.FeeSheetRules);    

                    this.processTaskCapDisplay(fsRowTemplate);

                    this.templateTasks.push(fsRowTemplate);

                } else {
                    let fsRowTemplate = this.templateTasks.find(x => x.FeeSheetTemplateTaskId === this.selectedFeeSheetTemplateId);

                    
                    if(fsRowTemplate){
                      fsRowTemplate.CapDisplay = cloned.CapDisplay;
                      fsRowTemplate.Description = cloned.Description;
                  
                      fsRowTemplate.FeeSheetTemplateRules = this.convertFeeSheetTemplateRules(cloned.FeeSheetRules);
                      fsRowTemplate.DeletedFeeSheetTemplateRules = this.convertFeeSheetTemplateRules(cloned.DeletedFeeSheetRules);
                      
                      this.processTaskCapDisplay(fsRowTemplate);
                    }
                }
            }
            
        }

        this.showFeeSheetRowDialog = false;
        this.selectedFeeSheetTemplateId = undefined;
    }

     processPhaseCapDisplay(feeSheetTemplatePhase: FeeSheetTemplatePhaseDto) : void {
       
        feeSheetTemplatePhase.CapDisplay = '';

        _.forEach(feeSheetTemplatePhase.FeeSheetTemplateRules, (item: FeeSheetTemplateRuleDto) => {
            let details = '';

            let countryDetail = '';
            if(item.CountryId && item.CountryId > 0) {
                let ctryDetail = _.find(this.countryList, (cntry : CountryDto) => cntry.CountryId === item.CountryId);

                countryDetail = ctryDetail ? ctryDetail.CountryCode : '';
            }

            //to be implemented
            let levelDetail = '';

            let capTargetDetail = this.forPhaseCapDisplayDetail(feeSheetTemplatePhase, item);
            
            details =`${countryDetail} ${levelDetail  + ' '}${capTargetDetail ? capTargetDetail + ':' : ''}
            ${this.$options.filters ? this.$options.filters.currency(item.Amount) : item.Amount}`;

            feeSheetTemplatePhase.CapDisplay = feeSheetTemplatePhase.CapDisplay + details + '<br/>';
        });

    }
     processTaskCapDisplay(feeSheetTemplateTask: FeeSheetTemplateTaskDto) : void {
        feeSheetTemplateTask.CapDisplay = '';

        _.forEach(feeSheetTemplateTask.FeeSheetTemplateRules, (item: FeeSheetTemplateRuleDto) => {
            let details = '';

            let countryDetail = '';
            if(item.CountryId && item.CountryId > 0) {
                let ctryDetail = _.find(this.countryList, (cntry : CountryDto) => cntry.CountryId === item.CountryId);

                countryDetail = ctryDetail ? ctryDetail.CountryCode : '';
            }

            //to be implemented
            let levelDetail = '';

            let capTargetDetail = this.forTaskCapDisplayDetail(feeSheetTemplateTask, item);
            
            details =`${countryDetail} ${levelDetail  + ' '}${capTargetDetail ? capTargetDetail + ':' : ''}
            ${this.$options.filters ? this.$options.filters.currency(item.Amount) : item.Amount}`;

            feeSheetTemplateTask.CapDisplay = feeSheetTemplateTask.CapDisplay + details + '<br/>';
        });

    }

    forPhaseCapDisplayDetail(feeSheetTemplatePhase: FeeSheetTemplatePhaseDto, item: FeeSheetTemplateRuleDto) : string {
        let result = '';
    
        let hasTarget = _.find(feeSheetTemplatePhase.FeeSheetTemplateRules, 
            (item : FeeSheetTemplateRuleDto) => item.Type === FeeSheetRuleTypeEnum.Target || item.TargetAmount != null);
   
        if(item.Type) {
            result = hasTarget ? item.Type : '';

            if(item.Type === FeeSheetRuleTypeEnum.Cap) {
                item.CapAmount = item.Amount;
                item.TargetAmount = undefined;
            }
            else {
                item.TargetAmount = item.Amount;
                item.CapAmount = undefined;
            }
        }
        else {
            //since 0 value also a false value
            if(item.CapAmount != null) {
                result = hasTarget ? FeeSheetRuleTypeEnum.Cap : '';
                item.Amount = item.CapAmount;
                item.Type = FeeSheetRuleTypeEnum.Cap;
            }
            else if(item.TargetAmount != null) {
                result = hasTarget ? FeeSheetRuleTypeEnum.Target : '';
                item.Amount = item.TargetAmount;
                item.Type = FeeSheetRuleTypeEnum.Target;
            }
        }  

        if(!item.Level) {
                item.Level = FeeSheetRuleLevelEnum.NA;
        }
        
        return result;
    }
    forTaskCapDisplayDetail(feeSheetTemplateTask: FeeSheetTemplateTaskDto, item: FeeSheetTemplateRuleDto) : string {
        let result = '';
    
        let hasTarget = _.find(feeSheetTemplateTask.FeeSheetTemplateRules, 
            (item : FeeSheetTemplateRuleDto) => item.Type === FeeSheetRuleTypeEnum.Target || item.TargetAmount != null);
   
        if(item.Type) {
            result = hasTarget ? item.Type : '';

            if(item.Type === FeeSheetRuleTypeEnum.Cap) {
                item.CapAmount = item.Amount;
                item.TargetAmount = undefined;
            }
            else {
                item.TargetAmount = item.Amount;
                item.CapAmount = undefined;
            }
        }
        else {
            //since 0 value also a false value
            if(item.CapAmount != null) {
                result = hasTarget ? FeeSheetRuleTypeEnum.Cap : '';
                item.Amount = item.CapAmount;
                item.Type = FeeSheetRuleTypeEnum.Cap;
            }
            else if(item.TargetAmount != null) {
                result = hasTarget ? FeeSheetRuleTypeEnum.Target : '';
                item.Amount = item.TargetAmount;
                item.Type = FeeSheetRuleTypeEnum.Target;
            }
        }  

        if(!item.Level) {
                item.Level = FeeSheetRuleLevelEnum.NA;
        }
        
        return result;
    }

    convertFeeSheetPhaseTemplate(row: FeeSheetTemplatePhaseDto | undefined){
        if (row){
            let ret: FeeSheetRowDto = {
                FeeSheetRowId: row.FeeSheetTemplatePhaseId,
                FeeSheetId: row.FeeSheetTemplateId ? row.FeeSheetTemplateId : "00000000-0000-0000-0000-000000000000",
                Description: row.Description,
                PhaseTypeId: row.PhaseTypeId,
                PhaseAliasId: row.PhaseAliasId,
                PhaseType: row.PhaseType,
                PhaseAlias: row.PhaseAlias,
                Signed: false,
                FeeSheetRules: [],
                CapDisplay : row.CapDisplay,
                
            }
            ret.FeeSheetRules = this.convertFeeSheetRules(row.FeeSheetTemplateRules);

            return _.clone(ret); 
        }
        else {
            return this.feeSheetRowDefaultValue();
        }
    }
    convertFeeSheetTaskTemplate(row: FeeSheetTemplateTaskDto | undefined){
        if (row){
            let ret: FeeSheetRowDto = {
                FeeSheetRowId: row.FeeSheetTemplateTaskId,
                FeeSheetId: row.FeeSheetTemplateId ? row.FeeSheetTemplateId : "00000000-0000-0000-0000-000000000000",
                Description: row.Description,
                InfractionTypeId: row.InfractionTypeId,    
                InfractionType: row.InfractionType,
                Signed: false,
                FeeSheetRules: [],
                CapDisplay : row.CapDisplay,
                
            }
            ret.FeeSheetRules = this.convertFeeSheetRules(row.FeeSheetTemplateRules);

            return _.clone(ret); 
        }
        else {
            return this.feeSheetRowDefaultValue();
        }
    }

    convertFeeSheetTemplateRules(rules: FeeSheetRuleDto[] | undefined){
        let templateRules: FeeSheetTemplateRuleDto[] = [];
        _.forEach(rules, (item: FeeSheetRuleDto) => {
            let rule: FeeSheetTemplateRuleDto = {
                FeeSheetTemplateRuleId: item.FeeSheetRuleId,
                CountryId: item.CountryId,
                CountryCode: item.CountryCode,
                TargetAmount: item.TargetAmount,
                CapAmount: item.CapAmount,
                Notes: item.Notes,
                Level: item.Level,
                Type: item.Type,
                Amount: item.Amount,
                Signed: item.Signed,
                InJurisdiction: item.InJurisdiction
            }

            if(this.feeSheetRowType === FeeSheetRowTypeEnum.Phase) {
                rule.FeeSheetTemplatePhaseId = item.FeeSheetRowId;
            }
            else { 
                rule.FeeSheetTemplateTaskId = item.FeeSheetRowId;
            }
            
            templateRules.push(rule);
        });
        return templateRules;
    }
    convertFeeSheetRules(rules: FeeSheetTemplateRuleDto[] | undefined){
        let fsRules: FeeSheetRuleDto[] = [];
        _.forEach(rules, (item: FeeSheetTemplateRuleDto) => {
            let rule: FeeSheetRuleDto = {
                FeeSheetRuleId: item.FeeSheetTemplateRuleId,
                FeeSheetRowId: item.FeeSheetTemplatePhaseId ? item.FeeSheetTemplatePhaseId : "00000000-0000-0000-0000-000000000000",
                CountryId: item.CountryId,
                CountryCode: item.CountryCode,
                TargetAmount: item.TargetAmount,
                CapAmount: item.CapAmount,
                Notes: item.Notes,
                Level: item.Level,
                Type: item.Type,
                Amount: item.Amount,
                Signed: item.Signed,
                InJurisdiction: item.InJurisdiction,
                FilingTypes: []
            }
            
            if(this.feeSheetRowType === FeeSheetRowTypeEnum.Phase) {
                rule.FeeSheetRowId = item.FeeSheetTemplatePhaseId ? item.FeeSheetTemplatePhaseId : "00000000-0000-0000-0000-000000000000";
            }
            else { 
                rule.FeeSheetRowId = item.FeeSheetTemplateTaskId ? item.FeeSheetTemplateTaskId : "00000000-0000-0000-0000-000000000000";
            }
            
            fsRules.push(rule);
        });
        return fsRules;
    }

  deletePhase(row: any): void {   
    if(row.PhaseAliasId)     {
      this.templatePhases = _.remove(this.templatePhases, item =>  item.PhaseAliasId !== row.PhaseAliasId);
    }
    else if(row.PhaseTypeId != undefined) {
      this.templatePhases = _.remove(this.templatePhases, item => item.PhaseTypeId !== row.PhaseTypeId);
    }
    
    
    // this.templatePhases
    //   .filter(p => row.PhaseTypeId ? row ===);
  }

    /*
  addInfraction(): void {    
    let infractionType = this.infractionTypeDtos[this.selectedInfraction];

    //if task already added
    if(this.templateTasks.filter(i => i.InfractionName == infractionType.Name).length > 0) {
      this.errorMessage = this.taskAlreadyAdded;
      this.errorVisible = true;
      return;
    }

    let templateTask: FeeSheetTemplateTaskDto = {      
      FeeSheetTemplateId: this.feeSheetTemplateId ? this.feeSheetTemplateId : undefined,
      InfractionTypeId: infractionType.InfractionTypeId,
      InfractionName: infractionType.Name,
      Description: "",
      FeeSheetTemplateRules: [], 
      CapDisplay: ""
    }
    this.templateTasks.push(templateTask);
  }
   

  deleteInfraction(row: any): void {    
    this.templateTasks = this.templateTasks
      .filter(t => t.InfractionTypeId != row.InfractionTypeId);
  }
  */
 
  
  feeSheetPhaseRemoveBtnClicked(data:any, phaseOrInfraction: string) : void {
        if(!this.DeletedFeeSheetTemplatePhases) {
            this.DeletedFeeSheetTemplatePhases = [];
        }

        if(data.data.FeeSheetTemplatePhaseId != "00000000-0000-0000-0000-000000000000") {
            this.DeletedFeeSheetTemplatePhases.push(data.data);
        }

        if(phaseOrInfraction === FeeSheetRowTypeEnum.Phase) {
            this.templatePhases.splice(data.rowIndex, 1);
        }
        else {
            this.templatePhases.splice(data.rowIndex, 1);
        }
    }

    processDataForEdit(data: any | undefined): void {

        if(this.feeSheetRowType === FeeSheetRowTypeEnum.Phase) {
            this.feeSheetRow =  this.convertFeeSheetPhaseTemplate(data.data);
            this.selectedFeeSheetTemplateId = data.data.FeeSheetTemplatePhaseId;
        } else {
            this.feeSheetRow =  this.convertFeeSheetTaskTemplate(data.data);
            this.selectedFeeSheetTemplateId = data.data.FeeSheetTemplateTaskId;
        }

        this.feeSheetRowModalType = FeeSheetModalType.Update;
        this.showFeeSheetRowDialog = true;
    }

  exitFeeSheetTemplate(): void {
    this.$router.push('/fee-sheet-templates');
  }

  setAttr(name: string, value: any) : any {
        return Object.keys(this.$attrs).indexOf(name) > -1 ? this.$attrs[name] : value;
  }

  saveFeeSheetTemplate(): void {
    if(this.templateName == "") {
      this.errorMessage = this.emptyTemplateName;
      this.errorVisible = true;
      return;  
    } 
    
    if(this.templatePhases.length == 0 && this.templateTasks.length == 0) {
      this.errorMessage = this.emptyPhasesOrTasks;
      this.errorVisible = true;
      return;
    }

     _.forEach(this.templatePhases, (fr : FeeSheetTemplatePhaseDto) => {
        _.forEach(fr.FeeSheetTemplateRules, (item : FeeSheetTemplateRuleDto) => {
            if(!item.CountryId && item.CountryId === 0) {
                item.CountryId = undefined;
            }
        });
    });
     _.forEach(this.templateTasks, (fr : FeeSheetTemplateTaskDto) => {
        _.forEach(fr.FeeSheetTemplateRules, (item : FeeSheetTemplateRuleDto) => {
            if(!item.CountryId && item.CountryId === 0) {
                item.CountryId = undefined;
            }
        });
    });
    let feeSheetTemplate: FeeSheetTemplateDto = {      
      TemplateName: this.templateName,
      Notes: this.templateNotes,
      InJurisdiction: this.templateInJurisdiction,
      FeeSheetTemplatePhases: this.templatePhases,
      FeeSheetTemplateTasks: this.templateTasks,
      DeletedFeeSheetTemplatePhases: this.DeletedFeeSheetTemplatePhases,
      DeletedFeeSheetTemplateTasks: this.DeletedFeeSheetTemplateTasks
    };

    if(this.feeSheetTemplateId) {
      //edit      
      feeSheetTemplate.FeeSheetTemplateId = this.feeSheetTemplateId;
      this.feeSheetTemplatesService
        .edit(this.feeSheetTemplateId, feeSheetTemplate)
        .then(result => {
          if(result.Data.TemplateName == null) {
            this.errorMessage = this.templateNameExists;
            this.errorVisible = true;
          }
          else {
            this.exitFeeSheetTemplate();
          }          
        });        
    }
    else{
      //create      
      this.feeSheetTemplatesService
        .create(feeSheetTemplate)
        .then(result => {
          if(result.Data.TemplateName == null) {
            this.errorMessage = this.templateNameExists;
            this.errorVisible = true;
          }
          else {
            this.exitFeeSheetTemplate();  
          }          
        });      
    }    
  }
}
